import gallery from "../components/gallerySplide";

gallery(3);
